var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19.96 21.31" }, props),
    React.createElement(
      "title",
      null,
      "arrow_checked_issues"
    ),
    React.createElement("path", { d: "M7.83 20.81a7 7 0 1 0-7.33-7 7.17 7.17 0 0 0 7.33 7", fill: "#fff" }),
    React.createElement("ellipse", { cx: "7.83", cy: "13.81", rx: "7.33", ry: "7", fill: "none", stroke: "#86d3f0" }),
    React.createElement("path", { d: "M19.27.76a.6.6 0 0 0-.46-.26.58.58 0 0 0-.46.26l-5.29 7.3-5.28 7.29-1.32-1.81-1.31-1.81a.56.56 0 0 0-.46-.26.57.57 0 0 0-.46.26 1.14 1.14 0 0 0-.19.63 1.17 1.17 0 0 0 .19.64l1.55 2.13 1.54 2.12a.57.57 0 0 0 .21.2.45.45 0 0 0 .25.07.44.44 0 0 0 .24-.07.68.68 0 0 0 .22-.2l5.51-7.61 5.52-7.61a1.12 1.12 0 0 0 .19-.63 1.17 1.17 0 0 0-.19-.64", fill: "#348ca9" }),
    React.createElement("path", { d: "M19.27.76a.6.6 0 0 0-.46-.26.58.58 0 0 0-.46.26l-5.29 7.3-5.28 7.29-1.32-1.81-1.31-1.81a.56.56 0 0 0-.46-.26.57.57 0 0 0-.46.26 1.14 1.14 0 0 0-.19.63 1.17 1.17 0 0 0 .19.64l1.55 2.13 1.54 2.12a.57.57 0 0 0 .21.2.45.45 0 0 0 .25.07.44.44 0 0 0 .24-.07.68.68 0 0 0 .22-.2l5.51-7.61 5.52-7.61a1.12 1.12 0 0 0 .19-.63 1.17 1.17 0 0 0-.19-.64z", fill: "none", stroke: "#338daa", strokeMiterlimit: "10" })
  );
});